import type { DisputeWorkflowStageResponse } from '@/types/api/disputes';
import { useApi } from './useApi';
import { useModeAwareQuery } from './useModeAwareQuery';

export function useDisputeWorkflowStages(disputeId: number | null) {
  const { apiGet } = useApi();

  return useModeAwareQuery<DisputeWorkflowStageResponse[], Error>(
    ['dispute-workflow-stages', disputeId],
    async ({ signal }) => {
      if (!disputeId) return [];
      return apiGet<DisputeWorkflowStageResponse[]>(`/api/v1/disputes/${disputeId}/workflow-stages`, undefined, signal);
    },
    [],
    {
      enabled: !!disputeId,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}
